import React from 'react';

const ChatIcon = ({text}) => (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 17" width="20" height="17">
            <g>
                <path
                      d="M16.78,0.34c1.42,0 2.58,1.16 2.58,2.58v8.33c0,1.42 -1.16,2.58 -2.58,2.58h-8.17l-5.42,3.78v-3.78c-1.42,0 -2.57,-1.16 -2.57,-2.58l0,-8.33c0,-1.42 1.16,-2.58 2.58,-2.58zM14.34,8.92h-8.71v1.1h8.71zM14.34,6.57h-8.71v1.1h8.71zM14.34,4.23h-8.71v1.1h8.71z"/>
            </g>
        </svg>
);

export default ChatIcon;
